<template>
  <div class="version-list">
    <scroll-comp ref="scrollComp" :page-load="getList">
      <template>
        <user-article-list-item
          v-for="item in list"
          :key="item.log_id"
          :show-user="false"
          :show-version="true"
          :item="item"
          layout="column"
        />
      </template>
    </scroll-comp>
  </div>
</template>

<script>
import { apiGetEditVersionList } from "@/api/contentApi";
import ScrollComp from "@/components/Scroll";
import UserArticleListItem from "./components/userArticleListItem";

export default {
  name: "version",
  mixins: [],
  props: {},
  model: {},
  components: {
    UserArticleListItem,
    ScrollComp
  },
  data() {
    return {
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      list: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getList();
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    pageLoad() {
      this.getList();
    },
    getList() {
      console.log(1);
      let { pagination, $refs, $route } = this;
      if ($refs.scrollComp.loadStatus) {
        return;
      }
      // 达到最大页数后，不触发翻页方法；
      if (pagination.page_no >= pagination.page_total) {
        $refs.scrollComp.loadStatus = "end";
        return;
      }
      ++pagination.page_no;
      let params = {
        ...pagination,
        type: 1,
        uid: $route.params.id
      };
      $refs.scrollComp.loadStatus = "loading";
      apiGetEditVersionList(params)
        .then(res => {
          if (res.code == 0) {
            const list = res.data.map(item => {
              return {
                ...item,
                log_id: item.id,
                id: item.content_id
              };
            });
            this.list = this.list.concat(list);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          // 达到最大页数后，不触发翻页方法；
          if (this.pagination.page_no >= this.pagination.page_total) {
            $refs.scrollComp.loadStatus = "end";
          } else {
            $refs.scrollComp.loadStatus = "";
          }
        });
    }
  }
};
</script>

<style scoped lang="less"></style>
